import { render, staticRenderFns } from "./SimpleGridTableComponent.vue?vue&type=template&id=a67b10dc&lang=pug"
import script from "./SimpleGridTableComponent.vue?vue&type=script&lang=ts"
export * from "./SimpleGridTableComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a67b10dc')) {
      api.createRecord('a67b10dc', component.options)
    } else {
      api.reload('a67b10dc', component.options)
    }
    module.hot.accept("./SimpleGridTableComponent.vue?vue&type=template&id=a67b10dc&lang=pug", function () {
      api.rerender('a67b10dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/SimpleGridTable/SimpleGridTableComponent.vue"
export default component.exports